import React, { useContext, useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Spin, Result, Button } from 'antd';
import axios from 'axios';
import { AuthContext } from '../contexts/AuthContext';
import { buildApiUrl } from '../config/api';

// OIDC 소셜 로그인 콜백 처리 페이지.
// 백엔드가 ${FRONTEND_URL}/oauth/callback#token=...&redirect=... (또는 #error=...) 로 리다이렉트한다.
const ERROR_MESSAGES = {
  missing_code: '인증 코드가 없습니다. 다시 시도해 주세요.',
  invalid_state: '보안 검증에 실패했습니다. 다시 시도해 주세요.',
  state_mismatch: '보안 검증에 실패했습니다. 다시 시도해 주세요.',
  domain_not_allowed: 'winteckorea.kr 계정만 로그인할 수 있습니다.',
  email_unverified: '이메일이 인증되지 않은 계정입니다.',
  unsupported_provider: '지원하지 않는 로그인 방식입니다.',
  server_error: '로그인 처리 중 서버 오류가 발생했습니다.',
};

const OAuthCallbackPage = () => {
  const navigate = useNavigate();
  const { login } = useContext(AuthContext);
  const [error, setError] = useState(null);
  const handled = useRef(false);

  useEffect(() => {
    if (handled.current) return; // StrictMode 이중 실행 방지
    handled.current = true;

    const raw = window.location.hash.startsWith('#')
      ? window.location.hash.slice(1)
      : window.location.hash;
    const params = new URLSearchParams(raw);
    const token = params.get('token');
    const errCode = params.get('error');
    const redirect = params.get('redirect') || '/main';

    if (errCode) {
      setError(ERROR_MESSAGES[errCode] || '로그인에 실패했습니다.');
      return;
    }
    if (!token) {
      setError('로그인 토큰을 받지 못했습니다.');
      return;
    }

    axios
      .get(buildApiUrl('/api/auth/oauth/session'), {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then(({ data }) => {
        login({
          User_ID: data.user.User_ID,
          token,
          User_Class_IDX: data.user.User_Class_IDX,
          menuPermissions: data.menu_permissions || [],
        });
        navigate(redirect, { replace: true });
      })
      .catch((err) => {
        setError(err.response?.data?.message || '로그인 세션 확인에 실패했습니다.');
      });
  }, [login, navigate]);

  if (error) {
    return (
      <Result
        status="error"
        title="로그인 실패"
        subTitle={error}
        extra={
          <Button type="primary" onClick={() => navigate('/', { replace: true })}>
            로그인 화면으로
          </Button>
        }
      />
    );
  }

  return (
    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
      <Spin size="large" tip="로그인 처리 중..." />
    </div>
  );
};

export default OAuthCallbackPage;
